// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.info-desc[data-v-215be202] {\n    width: auto;\n    display: inline;\n}\n.wrapper[data-v-215be202] {\n    padding: 30px;\n    border: 1px solid var(--grey-color);\n    border-radius: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
